// URL state management — template deep links now, full chart state later.
//
// Extension points for full state:
//   PARAM_STATE = 's'  — base64-encoded chart state (data + mapping + options)
//   PARAM_SHARE = 'id' — server-side share key (requires backend)

const PARAM_TEMPLATE = 'template'

export function getTemplateIdFromUrl() {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search).get(PARAM_TEMPLATE) || null
}

export function setTemplateInUrl(templateId) {
  if (typeof window === 'undefined') return
  const url = new URL(window.location.href)
  url.searchParams.set(PARAM_TEMPLATE, templateId)
  window.history.replaceState({}, '', url)
}

export function clearUrlState() {
  if (typeof window === 'undefined') return
  window.history.replaceState({}, '', window.location.pathname)
}

// ── Load deep links ────────────────────────────────────────────────────────────
// ?load=library              → open the sample library modal
// ?load=url&connector=X&...  → open URL tab with connector X pre-selected

export function getLoadParamsFromUrl() {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  const load = params.get('load')
  if (!load) return null
  if (load === 'library') return { type: 'library' }
  if (load === 'url') {
    const connector = params.get('connector')
    const connectorParams = {}
    for (const [k, v] of params.entries()) {
      if (k !== 'load' && k !== 'connector') connectorParams[k] = v
    }
    return { type: 'url', connector, params: connectorParams }
  }
  return null
}

export function setUrlTabLoad() {
  if (typeof window === 'undefined') return
  const url = new URL(window.location.href)
  url.search = ''
  url.searchParams.set('load', 'url')
  window.history.replaceState({}, '', url)
}

export function setLibraryLoad() {
  if (typeof window === 'undefined') return
  const url = new URL(window.location.href)
  url.search = ''
  url.searchParams.set('load', 'library')
  window.history.replaceState({}, '', url)
}

export function buildUrlTabShareUrl() {
  if (typeof window === 'undefined') return ''
  const url = new URL(window.location.href)
  url.search = ''
  url.searchParams.set('load', 'url')
  return url.toString()
}

export function buildLibraryShareUrl() {
  if (typeof window === 'undefined') return ''
  const url = new URL(window.location.href)
  url.search = ''
  url.searchParams.set('load', 'library')
  return url.toString()
}

export function buildConnectorShareUrl(connectorId, params = {}) {
  if (typeof window === 'undefined') return ''
  const url = new URL(window.location.href)
  url.search = ''
  url.searchParams.set('load', 'url')
  url.searchParams.set('connector', connectorId)
  for (const [k, v] of Object.entries(params)) {
    url.searchParams.set(k, String(v))
  }
  return url.toString()
}
